import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { MarkdownModule } from 'ngx-markdown';

import { provideHttpClient, withFetch } from '@angular/common/http';

// Importaciones de Firebase
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics, ScreenTrackingService } from '@angular/fire/analytics';

import { environment } from '../environments/environment';

//import { HttpClientModule } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes), 
    provideClientHydration(),
    provideAnimationsAsync(),
    importProvidersFrom(MarkdownModule.forRoot()), // For markdown visualization
    provideHttpClient(withFetch()), // For enable fetch for http client for server side rendering
    //importProvidersFrom(HttpClientModule),
    // Firebase configuration
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
  ]
};
